import { AppStore } from '../types/store';

const initialStore: AppStore = {
  auth: {
    authenticated: false,
    loading: false,
    error: [],
    message: null,
    email: '',
    password: '',
    returning: false,
    formErrors: [],
    loaded: false,
    tfa_challenge: false,
    tfa_token: '',
    integration_intent: ''
  },
  user: {
    redirected: false,
    data: null,
    loading: false,
    error: null,
    empty: true,
    idCheck: null,
    createNew: false,
    emailCheckComplete: false /* if user is in state awaiting email verification
    (i.e. "AwaitingVerification" or "AwaitingEmailVerification"), check that hasn't been updated by Auth0. */
  },
  resources: {
    loading: false,
    data: [],
    error: null
  },
  resource: {
    loading: false,
    data: [],
    aggregatedResource: null,
    error: null
  },
  fileThumb: {
    loading: false,
    data: [],
    error: null
  },
  files: {
    loading: false,
    allFiles: [],
    singleFile: null,
    error: null
  },
  requests: {
    data: [],
    item: null,
    working: [],
    didRequest: false,
    loading: false,
    error: null,
    signUrl: ''
  },
  banners: {
    data: []
  },
  institutions: {
    query: '',
    institutionsData: [],
    loadingInstitutions: false,
    institutionError: null,
    selectedInstitution: null,
    loadingSelected: false,
    selectedError: null,
    // institution addresses
    addressesData: [],
    loadingAddresses: false,
    addressesError: null,
    selectedAddresses: [],
    locationRxData: {},
    // single address
    singleAddress: {},
    singleAddressError: null,
    loading: false
  },
  status: {
    data: [],
    loading: false,
    error: null
  },
  allStatuses: {
    data: [],
    loading: false,
    error: null
  },
  shared: {
    data: [],
    loading: false,
    error: null
  },
  sharedResources: {
    data: [],
    loading: false,
    error: null
  },
  sharedResource: {
    data: [],
    loading: false,
    error: null
  },
  sharedFileInfo: {
    data: [],
    loading: false,
    error: null
  },
  sharedFileThumb: {
    data: [],
    loading: false,
    error: null
  },
  sharedFileView: {
    data: [],
    loading: false,
    error: null
  },
  sharedToken: { data: null },
  sharedAccessToken: { data: null }
};

export default initialStore;



// WEBPACK FOOTER //
// ./src/store/initialStore.js